import React, { useMemo } from "react";

// A calm animated falling-leaves background layer.
// Pure CSS/DOM (no external deps). ~28 leaves in muted greens/golds.
export default function FallingLeaves({ count = 28 }) {
  const leaves = useMemo(() => {
    const palette = [
      "#a7c4a0",
      "#8fb98a",
      "#c9d29a",
      "#e0c98a",
      "#d1b177",
      "#b3a26a",
      "#98b98f",
    ];
    return Array.from({ length: count }).map((_, i) => {
      const size = 14 + Math.random() * 22;
      const left = Math.random() * 100;
      const dur = 14 + Math.random() * 18;
      const delay = -Math.random() * dur;
      const sway = 3 + Math.random() * 4;
      const swayDelay = -Math.random() * sway;
      const color = palette[i % palette.length];
      return { i, size, left, dur, delay, sway, swayDelay, color };
    });
  }, [count]);

  return (
    <div className="leaves-layer" aria-hidden>
      {leaves.map((l) => (
        <span
          key={l.i}
          className="leaf"
          style={{
            left: `${l.left}%`,
            width: l.size,
            height: l.size,
            background: `linear-gradient(140deg, ${l.color} 0%, rgba(255,255,255,0.25) 100%)`,
            animationDuration: `${l.dur}s, ${l.sway}s`,
            animationDelay: `${l.delay}s, ${l.swayDelay}s`,
          }}
        />
      ))}
    </div>
  );
}
